import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteUserModuleAnswersInput {
	readonly userId: string;
	readonly moduleId: string;
}

export interface DeleteUserModuleAnswersParams {
	input: DeleteUserModuleAnswersInput;
}

@Injectable({ providedIn: 'root' })
export class DeleteUserModuleAnswersApiMutation extends ApiMutation<
	string[],
	DeleteUserModuleAnswersParams
> {
	client = 'content';
	document = gql`
		mutation DeleteUserModuleAnswers($input: DeleteUserModuleAnswersInput!) {
			deleteUserModuleAnswers(input: $input)
		}
	`;
	method = 'deleteUserModuleAnswers';
}
